import React from 'react';
import { SlideLayout } from '../ui/SlideLayout';
import { AlertTriangleIcon, FileXIcon, TrendingUpIcon } from 'lucide-react';
export function ExecutiveSummary() {
  return <SlideLayout data-id="element-143">
      <div className="mb-6 sm:mb-12" data-id="element-144">
        <div className="w-12 h-1 bg-gold-500 mb-4 sm:mb-6 rounded-full" data-id="element-145" />
        <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-146">
          Executive Summary
        </h2>
        <p className="text-sm sm:text-xl text-slate-500 max-w-3xl" data-id="element-147">
          A high-level overview of your current digital footprint and the path
          to growth.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-6 sm:mb-12" data-id="element-148">
        <div className="glass-card p-5 sm:p-8 relative overflow-hidden group" data-id="element-149">
          <div className="absolute top-0 right-0 p-4 sm:p-6 opacity-[0.03] group-hover:opacity-[0.06] transition-opacity" data-id="element-150">
            <AlertTriangleIcon className="w-16 sm:w-24 h-16 sm:h-24 text-slate-900" data-id="element-151" />
          </div>
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-red-500/10 flex items-center justify-center mb-4 sm:mb-6 border border-red-500/20" data-id="element-152">
            <AlertTriangleIcon className="w-5 h-5 sm:w-6 sm:h-6 text-red-500" data-id="element-153" />
          </div>

          <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-154">
            SEO & Conversion Issues
          </h3>
          <p className="text-sm sm:text-base text-slate-600 leading-relaxed" data-id="element-155">
            Your current website has critical SEO gaps and conversion barriers
            that are limiting organic visibility and lead generation potential.
          </p>
        </div>

        <div className="glass-card p-5 sm:p-8 relative overflow-hidden group" data-id="element-156">
          <div className="absolute top-0 right-0 p-4 sm:p-6 opacity-[0.03] group-hover:opacity-[0.06] transition-opacity" data-id="element-157">
            <FileXIcon className="w-16 sm:w-24 h-16 sm:h-24 text-slate-900" data-id="element-158" />
          </div>
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-orange-500/10 flex items-center justify-center mb-4 sm:mb-6 border border-orange-500/20" data-id="element-159">
            <FileXIcon className="w-5 h-5 sm:w-6 sm:h-6 text-orange-500" data-id="element-160" />
          </div>
          <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-161">
            Missing Revenue Pages
          </h3>
          <p className="text-sm sm:text-base text-slate-600 leading-relaxed" data-id="element-162">
            The site lacks dedicated mortgage service pages and
            location-specific landing pages — the highest-converting page types
            in the mortgage industry.
          </p>
        </div>

        <div className="glass-card p-5 sm:p-8 relative overflow-hidden group sm:col-span-2 md:col-span-1" data-id="element-163">
          <div className="absolute top-0 right-0 p-4 sm:p-6 opacity-[0.03] group-hover:opacity-[0.06] transition-opacity" data-id="element-164">
            <TrendingUpIcon className="w-16 sm:w-24 h-16 sm:h-24 text-slate-900" data-id="element-165" />
          </div>
          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-green-500/10 flex items-center justify-center mb-4 sm:mb-6 border border-green-500/20" data-id="element-166">
            <TrendingUpIcon className="w-5 h-5 sm:w-6 sm:h-6 text-green-500" data-id="element-167" />
          </div>
          <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-168">
            Growth Opportunity
          </h3>
          <p className="text-sm sm:text-base text-slate-600 leading-relaxed" data-id="element-169">
            A focused SEO and CRO strategy can significantly improve rankings,
            local search visibility, and qualified lead generation within 6
            months.
          </p>
        </div>
      </div>

      <div className="bg-slate-100 border-l-4 border-gold-500 rounded-r-xl p-4 sm:p-8 shadow-sm" data-id="element-170">
        <h4 className="text-xs sm:text-sm font-bold text-gold-600 uppercase tracking-widest mb-2 sm:mb-3" data-id="element-171">
          What This Means for Your Business
        </h4>
        <p className="text-sm sm:text-lg text-slate-700 leading-relaxed" data-id="element-172">
          Mortgage Pro Kingston is well-positioned in the Kingston market but is
          leaving significant revenue on the table. With targeted SEO
          improvements, dedicated service pages, and conversion optimization,
          your website can become your strongest lead generation asset — driving
          more qualified mortgage inquiries, pre-approval applications, and
          consultation bookings.
        </p>
      </div>
    </SlideLayout>;
}